import React from 'react'
import { Link } from 'react-router-dom'

const NoPageFound = () => {
    return (
        <div className="p-4 auth-body border rounded">
            <form>
                <ul className="row g-3 list-unstyled li_animate">
                    <li className="col-12 text-center">
                        <h1 className="display-1 fw-bold">4O4</h1>
                        <h5>We couldn't find this page.</h5>
                    </li>
                    <li className="col-12 mt-lg-4 mb-lg-2">
                        <Link className="btn btn-lg w-100 btn-primary text-uppercase mb-2" to="/" title="">Back to
                            Home</Link>
                    </li>
                </ul>
            </form>
        </div>
    )
}

export default NoPageFound